import { formatCurrency } from '@/utils/formatting';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const SmsPricingCardsBlock = ({ pricingCards }) => {
  return (
    <div className="my-20 flex flex-wrap justify-center gap-8 lg:mt-20">
      {pricingCards.map((card, index) => (
        <VisibleLoading key={card.id} delay={(index + 1) * 200}>
          {({ ref, className }) => <SmsPricingCard innerRef={ref} className={className} card={card} />}
        </VisibleLoading>
      ))}
    </div>
  );
};

export default SmsPricingCardsBlock;

const SmsPricingCard = ({ innerRef, className, card }) => {
  return (
    <div
      ref={innerRef}
      className={`flex w-[90vw] flex-col gap-3 rounded-2xl bg-white p-5 text-left shadow-2xl/15 lg:w-[380px] ${className || ''}`.trim()}
    >
      <div className="text-center font-semibold tracking-widest uppercase">{card.title}</div>

      <div className="mx-auto flex flex-wrap items-end justify-center gap-3 py-10 lg:w-[280px]">
        <div className="text-grey-950 text-xl font-light">{card.priceBefore}</div>
        <div className="text-grey-950 text-right text-4xl font-light lg:text-5xl">{formatCurrency(card.price)}</div>
        <div className="text-grey-500 text-xl font-light">{card.priceAfter}</div>
      </div>

      <div className="flex flex-1 flex-col gap-4 pb-6">
        {card.features.map((feature, index) => (
          <div key={index} className="text-grey-950 flex items-center gap-3">
            {feature.checked ? (
              <svg
                className="min-w-6"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" rx="12" fill="#D1FADF" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.098 7.39016L9.93797 14.3002L8.03797 12.2702C7.68797 11.9402 7.13797 11.9202 6.73797 12.2002C6.34797 12.4902 6.23797 13.0002 6.47797 13.4102L8.72797 17.0702C8.94797 17.4102 9.32797 17.6202 9.75797 17.6202C10.168 17.6202 10.558 17.4102 10.778 17.0702C11.138 16.6002 18.008 8.41016 18.008 8.41016C18.908 7.49016 17.818 6.68016 17.098 7.38016V7.39016Z"
                  fill="#12B76A"
                />
              </svg>
            ) : (
              <svg
                className="min-w-6"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" rx="12" fill="#E7E7E6" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.098 7.39016L9.93797 14.3002L8.03797 12.2702C7.68797 11.9402 7.13797 11.9202 6.73797 12.2002C6.34797 12.4902 6.23797 13.0002 6.47797 13.4102L8.72797 17.0702C8.94797 17.4102 9.32797 17.6202 9.75797 17.6202C10.168 17.6202 10.558 17.4102 10.778 17.0702C11.138 16.6002 18.008 8.41016 18.008 8.41016C18.908 7.49016 17.818 6.68016 17.098 7.38016V7.39016Z"
                  fill="#B0B0B0"
                />
              </svg>
            )}
            <span className="txt-md lg:txt-xl tracking-tight">{feature.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
